// import logo from './logo.svg';
import "./Home.css";
import "./css/style-car.css";
// import { Helmet } from "react-helmet"
import $ from "jquery";
// import { useEffect } from "react";
import React, { useState, useEffect } from "react";
// import React from "react";
import sprite from "./sprite.svg";

import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// const images = [
//   "./images/index2-slider-1.jpg",
//   "./images/index2-slider-2.jpg",
//   "./images/index2-slider-3.jpg",
// ];

var images = [
  {
    id: 1,
    url: "./images/index2-slider-1.jpg",
    name: "TAX",
    desc: "We are since 1983. We provide all services related to Tax and Business Development.",
    class: "",
  },
  {
    id: 2,
    url: "./images/index2-slider-2.jpg",
    name: "CONSULTING",
    desc: "The theme of our service is Art of providing Service to the Clients than there Expectation. ",
    class: "green",
  },
  {
    id: 3,
    url: "./images/index2-slider-3.jpg",
    name: "ADVISORY",
    desc: "We will take care of Your Accounting and Administrative Services and take the load off you.",
    class: "orange",
  },
];
// import  './js/jquery.min.js';
// import  './js/bootstrap.min.js';
// import  './js/jquery.sliderPro.min.js';
// import  './js/owl.carousel.min.js';
// import  './js/wow.min.js';
// import  './js/retina.min.js';
// import  './js/custom.js';

// <script src="js/jquery.min.js"></script>
// <script src="js/bootstrap.min.js"></script>
// <script src="js/jquery.hoverIntent.js"></script>
// <script src="js/superfish.min.js"></script>
// <script src="js/jquery.sliderPro.min.js"></script>
// <script src="js/owl.carousel.min.js"></script>
// <script src="js/odometer.min.js"></script>
// <script src="js/waypoints.min.js"></script>
// <script src="js/jquery.slicknav.min.js"></script>
// <script src="js/wow.min.js"></script>
// <script src="js/retina.min.js"></script>
// <script src="js/custom.js"></script>

function Home() {
  useEffect(() => {
    $(document).ready(function ($) {
      // "use strict";
      console.log("------@@@@@@@@@@--------");

      //  HEADER SLIDER HOOK
      // $('#index-slider2').fadeIn(1000);

      let set = 1;
      setInterval(function () {
        let cl = 0;
        $(".ind").each(function () {
          // console.log("cl-"+cl+"    set-"+set);
          var likeElement = $(this);
          if (cl === set) {
            likeElement.trigger("click");
          }
          // likeElement.trigger('click');
          // console.log(cl);
          if (cl === 0 || cl === 1) {
            cl++;
          } else {
            cl = 0;
          }
        });
        if (set === 0 || set === 1) {
          set++;
        } else {
          set = 0;
        }
      }, 7000);
    });
  }, []);

  const listItems = images.map((person) => (
    <div className="sp-slide" key={person.id}>
      <img className="sp-image" src={person.url} alt="" />
      <div className="hw-the-slider-content margintopsliderbox">
        <div className="row">
          <div className="col-sm-12">
            <div className="hw-the-slider-container">
              <div
                // className="hw-the-slider-captions sp-layer"
                className="hw-the-slider-captions sp-layer"
                data-show-transition="up"
                data-hide-transition="down"
                data-show-delay="800"
                data-hide-delay="800"
                data-stay-duration="5500"
                data-layer-init="true"
                style={{ visibility: "visible", left: 0, top: 0, opacity: 1 }}
              >
                <div className={"title-frame " + person.class}>
                  <span className="typcn typcn-chart-line"></span>
                  <h2>{person.name}</h2>
                  <hr className="small" />
                  <p>{person.desc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <>
      {/* <div className="box"> */}
      <div className="slider-pro" id="index-slider2">
        <div className="sp-slides">
          <Carousel
            useKeyboardArrows={true}
            renderIndicator={(clickHandler, isSelected, index) => {
              return (
                <li
                  onClick={clickHandler}
                  className={`ind ${isSelected ? "active" : ""}`}
                  key={index}
                  role="button"
                />
              );
            }}
            // statusFormatter={(currentItem, total) => {
            //   return (
            //     <p>
            //       image {currentItem} of {total}
            //     </p>
            //   );
            // }}
          >
            {listItems}
          </Carousel>
        </div>
      </div>

      {/* </div> */}

      <section className="introtext home2">
        <div className="row spacing-45">
          <div className="col-sm-12">
            <div className="block-grid-sm-4 block-grid-xs-1">
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="300ms"
              >
                <span className="typcn typcn-chart-pie"></span>
                <h3>Consumer Business</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="400ms"
              >
                <span className="typcn typcn-infinity"></span>
                <h3>Financial Services</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="500ms"
              >
                <span className="typcn typcn-input-checked"></span>
                <h3>Government Contracting</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="600ms"
              >
                <span className="typcn typcn-leaf"></span>
                <h3>Healthcare</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInLeft"
                data-wow-duration="300ms"
                data-wow-delay="700ms"
              >
                <span className="typcn typcn-lightbulb"></span>
                <h3>Manufacturing & Distribution</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInLeft"
                data-wow-duration="300ms"
                data-wow-delay="800ms"
              >
                <span className="typcn typcn-point-of-interest-outline"></span>
                <h3>Nonprofit Education</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInLeft"
                data-wow-duration="300ms"
                data-wow-delay="900ms"
              >
                <span className="typcn typcn-bookmark"></span>
                <h3>Tax Services</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
              <div
                className="block-grid-item wow fadeInLeft"
                data-wow-duration="300ms"
                data-wow-delay="1000ms"
              >
                <span className="typcn typcn-chart-area-outline"></span>
                <h3>Valuation Services</h3>
                {/* <p>Worldwide methodologies completely seamlessly empower.</p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="projects">
        <div className="row">
          <div className="col-sm-12">
            <h2>
              WELCOME TO <span>VT THOMAS & ASSOCIATES</span>
            </h2>
            <p className="text-center">
              VT Thomas & Associates is a leading Tax and Management Consultants
              firm having its head office at Kattappana, since 1982. We are the
              team of young and energetic partners having positive approach to
              provide expert and professional services with due care of
              professional ethics. We believe in steady approach towards
              offering high quality professional services to our clients has
              helped us immensely in building long term mutual benefit
              relationships. We offer fast and reliable services services of
              individual firm,company,partnership firm ,patent
              registration,income tax and sales tax returns, accounts
              management,business management etc.
            </p>
          </div>
        </div>

        <div className="row full-width no-gutter-all">
          <div className="col-sm-12">
            <div className="block-grid-sm-4 block-grid-xs-1 projectsposts">
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="300ms"
              >
                <a href="#" title="">
                  <figure>
                    <img src="images/project1.jpg" alt="" />
                    <figcaption>
                      <div className="fig-overlay">
                        <div className="thetitle">
                          <h6>CONSULTING</h6>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </a>
              </div>

              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="400ms"
              >
                <a href="#" title="">
                  <figure>
                    <img src="images/project2.jpg" alt="" />
                    <figcaption>
                      <div className="fig-overlay">
                        <div className="thetitle">
                          <h6>ADVISORY</h6>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </a>
              </div>
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="500ms"
              >
                <a href="#" title="">
                  <figure>
                    <img src="images/project3.jpg" alt="" />
                    <figcaption>
                      <div className="fig-overlay">
                        <div className="thetitle">
                          <h6>TAX</h6>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </a>
              </div>
              <div
                className="block-grid-item wow fadeInUp"
                data-wow-duration="300ms"
                data-wow-delay="600ms"
              >
                <a href="#" title="">
                  <figure>
                    <img src="images/project4.jpg" alt="" />
                    <figcaption>
                      <div className="fig-overlay">
                        <div className="thetitle">
                          <h6>AUDIT & ASSURANCE</h6>
                        </div>
                      </div>
                    </figcaption>
                  </figure>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="testimonials home2 greyback">
        <div className="row">
          <div className="col-sm-4">
            <h2>
              WHAT <span>OUR CUSTOMERS</span> HAVE TO SAY
            </h2>
            <hr className="small" />
            <p>
             Your Business Is Safe In Our Hands
            </p>
          </div>

          <div className="col-sm-8">
            <div id="customers-testimonials" className="owl-carousel">
              <div className="item">
                <div className="shadow-effect">
                  <p>
                    Completely synergize resource taxing relationships via
                    premier niche markets. Professionally cultivate one-to-one
                    customer service with robust ideas. Dynamically innovate
                    resource-leveling customer service for state of the art
                    customer service. learn more about this project.
                  </p>
                </div>
                <div className="testimonial-name home2">
                  <img
                    className="img-circle"
                    src="images/testimonial1.jpg"
                    alt=""
                  />
                  <span className="name">EMILIANO AQUILANI</span>
                  <span className="company">FOUNDER OF EMNI SA</span>
                </div>
              </div>
              <div className="item">
                <div className="shadow-effect">
                  <p>
                    Completely synergize resource taxing relationships via
                    premier niche markets. Professionally cultivate one-to-one
                    customer service with robust ideas. Dynamically innovate
                    resource-leveling customer service for state of the art
                    customer service. learn more about this project.
                  </p>
                </div>
                <div className="testimonial-name home2">
                  <img
                    className="img-circle"
                    src="images/testimonial2.jpg"
                    alt=""
                  />
                  <span className="name">GINA NAISMITH</span>
                  <span className="company">CEO OF SPML LTD</span>
                </div>
              </div>
              <div className="item">
                <div className="shadow-effect">
                  <p>
                    Completely synergize resource taxing relationships via
                    premier niche markets. Professionally cultivate one-to-one
                    customer service with robust ideas. Dynamically innovate
                    resource-leveling customer service for state of the art
                    customer service. learn more about this project.
                  </p>
                </div>
                <div className="testimonial-name home2">
                  <img
                    className="img-circle"
                    src="images/testimonial3.jpg"
                    alt=""
                  />
                  <span className="name">FIONA TOWER</span>
                  <span className="company">CHAIRMAN AT RCL INC.</span>
                </div>
              </div>
              <div className="item">
                <div className="shadow-effect">
                  <p>
                    Completely synergize resource taxing relationships via
                    premier niche markets. Professionally cultivate one-to-one
                    customer service with robust ideas. Dynamically innovate
                    resource-leveling customer service for state of the art
                    customer service. learn more about this project.
                  </p>
                </div>
                <div className="testimonial-name home2">
                  <img
                    className="img-circle"
                    src="images/testimonial4.jpg"
                    alt=""
                  />
                  <span className="name">MICHAEL TREMANSAU</span>
                  <span className="company">FOUNDER OF INDEX SA</span>
                </div>
              </div>
              <div className="item">
                <div className="shadow-effect">
                  <p>
                    Completely synergize resource taxing relationships via
                    premier niche markets. Professionally cultivate one-to-one
                    customer service with robust ideas. Dynamically innovate
                    resource-leveling customer service for state of the art
                    customer service. learn more about this project.
                  </p>
                </div>
                <div className="testimonial-name home2">
                  <img
                    className="img-circle"
                    src="images/testimonial5.jpg"
                    alt=""
                  />
                  <span className="name">SCOTTY ECKLESTON</span>
                  <span className="company">CEO OF NUMBERS LTD</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      <section
        className="clients home2 wow fadeInUp"
        data-wow-duration="300ms"
        data-wow-delay="450ms"
      >
        <div className="row">
          <div className="col-sm-12">
            <h2>
              VT THOMAS & ASSOCIATES SUPPORTS <span>1000+</span> CLIENTS
            </h2>
            <p className="text-center">
            We provide full range of accounting,taxation ,management, and financial service geared towards assisting all sectors.
            we focus on quality,we are offering services of individual firm,company,partnership firm ,patent registration,income tax and sales tax returns, accounts management,business management etc
            </p>

            <div id="clients-carousel" className="owl-carousel">
              <div className="item">
                <img src="images/clients/1.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/2.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/3.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/4.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/5.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/6.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/7.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/8.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/9.png" alt="" />
              </div>
              <div className="item">
                <img src="images/clients/10.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
